import React, { PropsWithChildren, useMemo, useState } from 'react';
import { FlexyFilterContext } from './FlexyFilterContext';

export const FlexyFilterProvider = function (props: PropsWithChildren) {
    const { children } = props;
    const [rawValue, setRawValue] = useState<unknown | null>(null);
    const [selectedItem, setSelectedItem] = useState<unknown>(null);
    const contextValue = useMemo(
        () => ({ rawValue, setRawValue, selectedItem, setSelectedItem }),
        [rawValue, setRawValue, selectedItem, setSelectedItem],
    );

    return (
        <FlexyFilterContext.Provider value={contextValue}>{children}</FlexyFilterContext.Provider>
    );
};
